import { render } from "./CreatedBy.vue?vue&type=template&id=b9cce2d8"
import script from "./CreatedBy.vue?vue&type=script&lang=js"
export * from "./CreatedBy.vue?vue&type=script&lang=js"

import "./CreatedBy.vue?vue&type=style&index=0&id=b9cce2d8&lang=scss"

import exportComponent from "/home/bshipaa/sites/app.bitesizehipaa.com/bss/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__